<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter"><a id="page2"></a><a id="page3"></a><a href="#/OEBPS/toc.htm#p1-ack">ACKNOWLEDGEMENTS</a></h1>
<p class="nonindent">I’d like to thank Linzi Moody for her much-tried patience, her support and for the constant flow of ideas and suggestions that have made this a better book than it would otherwise have been; Christine Hamilton, Mary Timlin and Jennifer Young for helpful suggestions and for bearing with me while we trawled the delights of the City of Culture; my journalistic colleagues who couldn’t be more different from the heartless hacks I sometimes portray; Simon Travers, who explained the myth of fingerprints; and last but not least, my agents, Jane Gregory and Lisanne Radice whose unfailing good humour and encouragement help to keep me sane.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p1-ack.vue?86520fdc